import Vue from 'vue';
import VueI18n from 'vue-i18n';
import store from '@/store';
// import Avue from '@smallwei/avue';
import elementEnLocal from 'element-ui/lib/locale/lang/en'
import elementZhLocal from 'element-ui/lib/locale/lang/zh-CN'
Vue.use(VueI18n);

const DEFAULT_LANG = store.state.appstore.language;
const LOCALE_KEY = 'localeLanguage';

const locales = {
  zh_cn: {
    ...require('./zh_cn.json'),
    ...elementZhLocal
    // ...Avue.locale.zh
  },
  en: {
    ...require('./en.json'),
    ...elementEnLocal
    // ...Avue.locale.en
  }
};

const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales
});

const geti18n = async(lang = 'zh_cn') => {
  if (lang) {
    i18n.setLocaleMessage(lang, locales[lang]);
  }
};

export const setup = (lang) => {
  if (lang === undefined) {
    lang = window.localStorage.getItem(LOCALE_KEY);
    if (locales[lang] === undefined) {
      lang = DEFAULT_LANG;
    }
  }
  store.dispatch('setLanguage', lang);
  window.localStorage.setItem(LOCALE_KEY, lang);
  const html = document.querySelector('html');
  Object.keys(locales).forEach((lang) => {
    html.classList.remove(`lang-${lang}`);
  });
  geti18n(lang);
  html.classList.add(`lang-${lang}`);
  html.setAttribute('lang', lang);
  Vue.config.lang = lang;
  i18n.locale = lang;
};

setup(DEFAULT_LANG);
window.$t = i18n;
export default i18n;
